import { style } from "@vanilla-extract/css";
import { theme } from "../../theme/css/theme.css";

export const errorContainer = style({
  color: theme.colors.error,
  paddingLeft: theme.spacings.xxs,
  lineHeight: "140%",
});
